import { DefaultFetchError, FetchCreate, useFetchCreate } from '../fetch';

/** These fields present only if use internal API call, and not MBS alternative */
export interface InternalContractFields {
  tariffId?: number;
}

export interface IContract extends InternalContractFields {
  contractNumber: string;
  tariffName: string;
  state: string;
  deliveryAddress: DeliveryAddress;
  section: string;
  periodStart: number;
  periodEnd: number;
  bonus: unknown[];
  nextPossibleCancellationDate: number;
  possibleInvoicingIntervals: number[];
  invoicingInterval: number;
  tariffChangePossible: boolean;
  revokeContractPossible: boolean;
  inboxDate: number;
  contractConclusionDate: number;
  readoutType: string;
  changeOfInvoicingIntervalPossible: boolean;
}

export interface DeliveryAddress {
  periodStart: number;
  periodEnd: unknown;
  id: number;
  street: string;
  housenumber: string;
  housenumberAddition: unknown;
  postalCode: string;
  city: string;
  cityAddition: unknown;
  federalState: unknown;
  adressAddition: unknown;
  changedCreateE03: boolean;
  country: string;
  adressAddition1: unknown;
  adressAddition2: unknown;
  adressAddition3: unknown;
  adressAddition4: unknown;
}

/** Tariff application: */
interface GetTariffApplicationParams {
  contractNumber: string;
}
export interface GetTariffApplicationData {
  id: number;
  creationDate: number;
  periodStart: null;
  periodEnd: null;
  tariffId: number;
  tariffName: string;
  tariffNameExternal: string;
  contract: number;
  active: true;
  canceled: null;
  energyPriceNet: number;
  energyPriceTax: null;
  energyPriceGross: number;
  energyPriceIndividualNet: number;
  energyPriceNtNet: null;
  energyPriceNtTax: null;
  energyPriceNtGross: null;
  baseFeeNet: number;
  baseFeeTax: number;
  baseFeeGross: number;
  variablePriceComponentPercentage: number;
  advancePayIntervalInMonth: null;
  lowerLimit: null;
  upperLimit: null;
  priceGuarantyForInMonth: number;
  priceGuarantyEnd: null;
  runtimeInMonth: number;
  runtimeUntilEndOfMonth: false;
  nextPossibleCancellationDate: number;
  renewalInMonth: number;
  cancellationTerm: number;
  cancellationTermUnit: string;
  cancellationTermTo: string;
  cancellationTermToFixed: false;
  cancellationCalculateFromSignatureDate: false;
  bonusApplications: [];
}

export const useGetTariffApplication = (contractNumber: string): FetchCreate<
  GetTariffApplicationData, DefaultFetchError, GetTariffApplicationParams> => (
  useFetchCreate('proxy/portal/tariff/getTariffApplication', {
    config: {
      transformRequest: [(payload: GetTariffApplicationParams) => payload?.contractNumber || contractNumber || ''],
      headers: {
        'Content-Type': 'text/plain;charset=UTF-8',
      },
    },
    autoStart: false, // !!contractNumber,
  })
);
